
export const environment = {
    production: true,
    clientId: '3b5b63c5-7f76-47ae-9884-b14950aa489f',
    authority: 'https://login.microsoftonline.com/705d07a3-2eea-4f3b-ab59-65ca29abeb26/',
    redirectUri: 'https://protibimbo.jti.com/',
    postLogoutRedirectUri: 'https://protibimbo.jti.com/',
    exposed_api: 'api://3b5b63c5-7f76-47ae-9884-b14950aa489f',
    apiBaseUrl: 'https://protibimbo.jti.com/',
};




/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
